import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import timezone from 'dayjs/plugin/timezone';
import duration from 'dayjs/plugin/duration';
import { GlobalStyles, StyledEngineProvider } from '@mui/material';

import { Config } from 'config';
import { ErrorBoundary } from 'components';

import App from './App';

const { sentry } = Config;

if (sentry.dsn) {
  if (sentry.release) {
    console.log(`VERSION ${sentry.release}`);
  }
  try {
    Sentry.init({
      dsn: sentry.dsn,
      enableLogs: true,
      tracesSampleRate: 1.0,
      environment: sentry.env,
      release: sentry.release,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      integrations: [
        Sentry.replayIntegration(),
        Sentry.browserTracingIntegration(),
      ],
      ignoreErrors: [
        'AxiosError',
        'TimeoutError',
        'Loading chunk',
        "Unexpected token '<'",
        'Failed to fetch dynamically',
      ],
    });
  } catch (error) {
    console.error(error);
  }
}

if (Config.waf.apiUrl) {
  const AwsWafScript = document.createElement('script');
  AwsWafScript.id = 'AwsWAFScript';
  AwsWafScript.async = false;
  AwsWafScript.src = Config.waf.apiUrl;
  document.head.appendChild(AwsWafScript);
}

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <StyledEngineProvider enableCssLayer>
    <GlobalStyles styles="@layer theme, base, mui, components, utilities;" />
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StyledEngineProvider>
);
